const Api = {
  login: "/api/accounts/login/",
  logout: "/api/accounts/logout/",
  user: "/api/accounts/user-detail/",
  upload_recording: "/api/speech_recognition/upload_recording/",
  recording_status: "/api/speech_recognition/recording_status/",
  update_transcription: "/api/speech_recognition/update_transcription/",
  update_summary: "/api/speech_recognition/update_summary/",
  upload_document_ocr: "/api/ocr/upload_document/",
  document_details: "/api/ocr/get_document_details/",
  postChatOcrMessage: "/api/ocr/insights_chatbot/",
  summarize: "/api/summarization/summarize/",
  summarize_chart: "/api/summarization/summarize-chart/",
  summarize_status: "/api/summarization/summary_status/",
  summary_types: "/api/summarization/summary_types/",
  summary_details: "/api/summarization/summary_details/",
  summary_kpi: "/api/summarization/summarize-kpi/",
  postChatbotMessage: "/api/chatbot/converse/",
  notifications: "/api/notification_center/notifications/",
  audit_list: "/api/call_evaluation/list/",
  check_access_status: "/api/call_evaluation/check_access_status/",
  project_list: "/api/users/project-list/",
  details: "/api/call_evaluation/details/",
  load_file_and_kid: "/api/call_evaluation/load_file_and_kid/",
  send_key_authorized_user: "/api/call_evaluation/send-key-authorized-user/",
  change_status: "/api/call_evaluation/change_status/",
  get_action_status: "/api/call_evaluation/get_action_status/",
  access_start_end_time: "/api/call_evaluation/access_start_end_time",
  manual_review: "/api/call_evaluation/manual_review/",
  template_list: "/api/call_evaluation/template/",
  create_template: "/api/call_evaluation/create-template/",
  update_template: "/api/call_evaluation/update-template/",
  delete_template: "/api/call_evaluation/delete-template/",
  evaluation_dashboard: "/api/call_evaluation/call_evaluation_dashboard/",
  agent_dashboard: "/api/call_evaluation/agent_highlight_dashboard/",
  agent_leader_board: "/api/call_evaluation/agent-leader-board/",
  outlier_agent_report: "/api/call_evaluation/outlier_agent_report/",
  failure_count_category: "/api/call_evaluation/failed_category_count/",
  domain_category: "api/base/lookups/domain/",
  evaluation_type: "/api/call_evaluation/lookup/evaluation-type",
  language_category: "api/base/lookups/language/",
  upload_document_ocr_kpi: "/api/ocr/upload_document_kpi/",
  agent_scoring_sentiments: "/api/call_evaluation/agent_scoring_vs_sentiment/",
  top_violations_by_categories: "/api/call_evaluation/top_violations_by_categories/",
  campaigns: "/api/call_evaluation/campaigns/",
  services: "/api/call_evaluation/services/",
  top_ten_violations: "/api/call_evaluation/top_ten_violations/",
  speech_recognition_kpi: "/api/speech_recognition/upload_recording_kpi/",
  agent: "/api/accounts/user_list/agent/",
  qa_supervisor: "/api/accounts/user_list/qa_supervisor/",
  employee_list: "/api/accounts/users/",
  deactivate_user: "/api/accounts/deactivate_user/",
  create_user: "/api/accounts/create_user/",
  department_list: "/api/accounts/department_list/",
  entity_list: "/api/accounts/entity_list/",
  edit_user: "/api/accounts/edit_user/",
  user_by_id: '/api/accounts/user_by_id/',
  role_list: '/api/access_mgmt/role_list/',
  export_user_list: '/api/accounts/export-user-list/',
  user_upload: '/api/accounts/user-upload/',
  location_list:"/api/accounts/location_list/",
  company_group_list: '/users/api/company-group-list/?',
  company_pay_group_list: '/users/api/company-pay-group-list/?',
  job_code_list: '/users/api/job-code-list/',
  agent_performance_kpi: 'api/call_evaluation/agent_performance/',
  purpose_call_distribution:'api/call_evaluation/purpose_call_distribution/',
  call_sentiment_vs_score:'/api/call_evaluation/call_sentiment_vs_score/',
  sentiment_analysis: '/api/call_evaluation/sentiment_analysis/',
  sentiment_word_cloud: '/api/call_evaluation/sentiment_word_cloud/',
  sentiment_timing: '/api/call_evaluation/sentiment_timing/',
  emotion_analysis: '/api/call_evaluation/emotion_analysis/',
  update_Offensive_Word_Notification:"/api/call_evaluation/profanity_identification/",
  category_list: "/api/call_evaluation/category-list/",
  conversational_tag_mappings: '/api/call_evaluation/conversational_tag_mappings/',
  conversational_tags: '/api/call_evaluation/conversational_tags',
  knowledgebase_manage_query: '/api/knowledge_base/manage-queries/', //temp static
  search_query_knowledgebase: '/api/knowledge_base/',
  agent_violation_list: "/api/call_evaluation/agent_violation_list",  //temp static
  agent_level_scoring_vs_sentiment_list: "/api/call_evaluation/agent_violation_list",  //temp static
  purpose_of_call_distribution: "/api/call_evaluation/purpose_of_call_distribution"  //temp static
};
export default Api;
